import { getAgentAvatarColor } from '@atlaskit/rovo-agent-components/ui/agent-avatar/GeneratedAvatar';

import type { AgentInfo } from '../decoration/reducer';

type AIContentDecorationAttrs = {
	class: string;
	'data-testid': string;
	style?: string;
};

/**
 * Used to apply alpha to the background color. Resilient to format of color changing (e.g. hex, rgb, hsl)
 * @param color source color
 * @param alpha alpha value between 0 and 1
 * @returns color string with alpha applied
 */
const withAlpha = (color: string, alpha: number): string => {
	return `color-mix(in srgb, ${color} ${alpha * 100}%, transparent)`;
};

export const getAIContentDecorationAttrs = ({
	agentInfo,
	useAgentHighlightColor,
}: {
	agentInfo?: AgentInfo;
	useAgentHighlightColor: boolean;
}): AIContentDecorationAttrs => {
	if (!useAgentHighlightColor || !agentInfo) {
		return {
			class: 'ai-in-editor-ai-content',
			'data-testid': 'ai-in-editor-ai-content',
		};
	}

	const color = getAgentAvatarColor({
		agentId: agentInfo.agentId,
		agentIdentityAccountId: agentInfo.agentIdentityAccountId,
		agentNamedId: agentInfo.agentNamedId ?? undefined,
	});

	return {
		class: 'ai-in-editor-ai-content',
		'data-testid': 'ai-in-editor-ai-content',
		style: `background-color: ${withAlpha(color.secondary, 0.2)}; border-bottom-color: ${
			color.primary
		};`,
	};
};
